import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import {catchError, concatMap, map, switchMap, withLatestFrom} from 'rxjs/operators';
import {EMPTY, of} from 'rxjs';
import { CountryActionTypes, CountryActions } from '../actions/country.actions';
import {Store} from '@ngrx/store';
import * as fromStore from '../../../store';
import {AccountService} from '../../../services/account.service';
import * as featureActions from '../../index';


@Injectable()
export class CountryEffects {
  private actions$ = inject(Actions);
  private accountService = inject(AccountService);

  constructor() {}

  loadCountrys$ = createEffect(() => this.actions$.pipe(
    ofType(featureActions.CountryActionTypes.GetCountrys),
    switchMap(() => {
      return this.accountService.ReadCountryList().pipe(
        map((res) => {
          if (Array.isArray(res) && res.length > 0) {
            return new featureActions.LoadCountrys(res);
          } else {
            return new featureActions.LoadCountrys([]);
          }
        }),
        // TODO: catchError Message調整 --> 留待未來再回頭定義Error Message
        catchError(error => {
          return of(new featureActions.GetCountrysFail());
        })
      );
    })
  ));




}
